module.exports = __webpack_public_path__ + "static/media/e2f9a217.jpg";